import {REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION} from '@colonist/types'
import {ClientUserState} from './ClientUserState.ts'
import {UIDeviceController} from './ui_html/UIDeviceController.ts'
import {UIUrlController} from './ui_html/UIUrlController.ts'
import {StorageWrapper} from './StorageWrapper.ts'
import {UIPortraitModeOptInPopup} from './ui_popup/UIPortraitModeOptInPopup.tsx'
import {UISwitchToPortraitPopup} from './ui_popup/UISwitchToPortraitPopup.tsx'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'

export class ClientPlatformRedirection {
    static handleAccountRedirection() {
        if(!UIDeviceController.isUserOnMobileWebBrowser()) return
        if(this.shouldSkipAnyRedirection()) return

        const isGuestUser = !ClientUserState.userState?.isLoggedIn

        if(isGuestUser) {
            this.handleRedirectNewAccountsToMobileWeb()
            return
        }

        const colonistVersion = ClientUserState.userState?.colonistVersion
        const isNewUser = colonistVersion != undefined && colonistVersion >= REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION

        if(!isNewUser) return

        this.handleRedirectNewAccountsToMobileWeb()
    }

    static handlePortraitModeEnforcement() {
        if(this.shouldSkipAnyRedirection()) return

        const isMobileWebUserAlreadyOnMobilePath = UIDeviceController.isUserOnMobileWebBrowser() && this.isOnMobilePath()
        const isMobileAppUserAlreadyOnPortraitMode = UIDeviceController.isUserOnMobileWebview() && StorageWrapper.isPortraitGamePlayEnabled()
        const isNotEligibleToShowPopup = isMobileWebUserAlreadyOnMobilePath || isMobileAppUserAlreadyOnPortraitMode

        if(isNotEligibleToShowPopup) return

        if(!UIUtilsEjsVariables.portraitModeEnforcementDate) return

        const accepted = StorageWrapper.getPortraitModeEnforcementAccepted()
        if(accepted == true) {
            this.handleRedirectNewAccountsToMobileWeb()
            return
        }
        if(accepted == false) return

        this.showPortraitModeOptInPopup()
    }

    private static showPortraitModeOptInPopup() {
        const optInPopup = new UIPortraitModeOptInPopup(() => {
            const switchPopup = new UISwitchToPortraitPopup(() => {
                StorageWrapper.setPortraitModeEnforcementAccepted(false)
            })
            switchPopup.show()
        })
        optInPopup.show()
    }

    private static isUserOnLandingPage(): boolean {
        // Should be similar logic in code/client/web/views/pages/ejs_shared/first-scene-detection.ejs
        if(!UIUrlController.isUrlPathRoot()) return false
        if(this.isOnMobilePath()) return false
        if(ClientUserState.userState?.isLoggedIn) return false
        const hasCompletedOneGame = (ClientUserState.userState?.totalCompletedGameCount ?? 0) > 0
        if(hasCompletedOneGame) return false

        return true
    }

    private static shouldSkipAnyRedirection(): boolean {
        if(!UIDeviceController.isUserOnMobileDevice()) return true
        if(UIDeviceController.isUserOnTabletDevice()) return true
        if(this.isUserOnLandingPage()) {
            const hasNoRoomId = UIUrlController.getRoomIdFromUrl() == undefined
            return hasNoRoomId
        }

        const isRulebookPage = window.location.pathname.includes('/catan-rules')
        if(isRulebookPage) return true

        return false
    }

    private static isOnMobilePath(): boolean {
        return window.location.pathname.includes('/mobile')
    }

    static handleRedirectNewAccountsToMobileWeb() {
        StorageWrapper.setPortraitGamePlayEnabled(true)

        if(this.isOnMobilePath()) return
        const languagePrefix = UIUrlController.getLanguagePrefix()
        const newUrl = languagePrefix + '/mobile' + UIUrlController.getRelativeUrlWithoutLanguagePrefix()
        window.location.href = this.removeTrailingSlash(newUrl)
    }

    private static removeTrailingSlash(url: string): string {
        return url.replace(/\/([?#])/, '$1')
    }
}
